import { render, staticRenderFns } from "./number-span.vue?vue&type=template&id=445010ed&scoped=true&"
import script from "./number-span.vue?vue&type=script&lang=ts&"
export * from "./number-span.vue?vue&type=script&lang=ts&"
import style0 from "./number-span.vue?vue&type=style&index=0&id=445010ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445010ed",
  null
  
)

export default component.exports